<template>
  <div class="main">
    <c-panel title="Monitores" titleIcon="fas fa-user-check">
      <list></list>
    </c-panel>
  </div>
</template>

<script>
import list from "./list"

export default {
  components: { list }
}
</script>

